import type { StoreApi, UseBoundStore } from 'zustand';

type ExtractState<S> = S extends { getState: () => infer X } ? X : never;

export const createStoreHook =
  <TState extends StoreApi<unknown>>(useStore: UseBoundStore<TState>) =>
  <TSelection>(selector: (state: ExtractState<TState>) => TSelection) => {
    return () => useStore(selector);
  };
